






import {Component} from 'vue-property-decorator';
import Vue from 'vue';
import {Action} from 'vuex-class';
import InviteDetailComponent from '@/components/invite/invite-detail.vue';
import VisitViewComponent from '@/components/profile/visitor-view.vue';

@Component({
  components: {
    VisitViewComponent
  }
})
export default class HomeComponent extends Vue {
  @Action('_Loading', {namespace: 'loading'}) Loading!: (payload: boolean) => Promise<void>;


  public move = false;

  async mounted() {
    this.Loading(false);
  }
}
